export default __webpack_public_path__ + "7b25b26068b1f3a5a247721ae884eea2.png";